// Service page translations
const serviceTranslations = {
  en: {
    hero: {
      kicker: "services / thewhizkind",
      title: "our <span>services</span>",
      intro: {
        lead: "ideas, design, technology and business — working as one.",
        text: "sometimes that's a website. sometimes an identity. sometimes it's an automation, a digital tool or a process that simply shouldn't be manual anymore."
      }
    },
    index: {
      label: "Service categories"
    },
    groups: {
      automation: {
        title: "ai, automation & tools",
        slug: "ai-automation-tools",
        formattedTitle: ["ai,", "automation", "& tools"],
        intro: "less time spent on repetitive work. more room for the work that needs a person.",
        services: {
          aiAutomation: ["ai & automation", "workflows that reduce manual tasks, connect information and make everyday work a little easier."],
          privateLocalAi: ["private & local ai", "ai built around your own data and infrastructure — so sensitive information doesn't have to leave your environment."],
          processOptimisation: ["process optimisation", "finding unnecessary steps before deciding what should be simplified, connected or automated."],
          customTools: ["custom tools", "sometimes the right tool does not exist. so we build it."]
        },
        inlineLink: "see what we're experimenting with"
      },
      webDigital: {
        title: "web & digital",
        slug: "web-digital",
        intro: "digital experiences designed and developed as one — around what people actually need to do.",
        services: {
          webDevelopment: ["web development", "responsive, accessible and fast websites — thoughtfully designed, carefully built."],
          digitalisation: ["digitalisation", "turning manual, fragmented or outdated ways of working into practical digital processes."]
        }
      },
      finance: {
        title: "finance & business",
        slug: "finance-business",
        intro: "bringing structure to the business side of good ideas.",
        services: {
          finance: ["finance", "bringing financial thinking into digital projects and making complex data easier to work with."],
          creativeDevelopment: ["creative development", "turning early ideas into useful, viable projects with a clearer direction."]
        }
      },
      brandDesign: {
        title: "brand & design",
        slug: "brand-design",
        intro: "identities and communication systems that make an idea clear, recognisable and useful.",
        services: {
          brandingIdentity: ["branding & identity", "from the first idea to a visual system around it — identities, typography, colour and guidelines built to stay recognisable."],
          graphicDesign: ["graphic design", "campaigns, publications, presentations, posters and digital content — designed to communicate clearly and look like they belong together."],
          communication: ["communication", "making information clearer and easier to understand across channels and audiences."]
        },
        inlineLink: "see selected visual work"
      }
    },
    liveOnTheWeb: {
      title: "live on the web"
    },
    process: {
      title: "how we work",
      sectionTitle: "no fixed recipe",
      steps: [
        ["01", "understand", "what's actually the problem?"],
        ["02", "think", "what would make it better?"],
        ["03", "make", "design it. build it. test it."],
        ["04", "improve", "because version one rarely needs to be version forever."]
      ]
    },
    clients: {
      kicker: "who we work with",
      title: "different sizes.<br />same curiosity.",
      scale: "startups / organisations / cultural institutions / education / businesses / independent projects",
      paths: [
        "some come with a detailed brief.",
        "some come with a problem.",
        "some come with there has to be a better way to do this.",
        "some just come with a hallo."
      ],
      emphasis: "all good places to start."
    },
    faq: {
      title: "good questions",
      sectionTitle: "before we <span>begin</span>",
      questions: [
        ["do you only work on projects in frankfurt?", "no. we are based in frankfurt am main, with roots in new delhi, and work with people and organisations across borders and time zones."],
        ["can you handle design and development together?", "yes. bringing both together is often the best way to keep an idea coherent from its first sketch to the finished experience."],
        ["do you work with existing websites and systems?", "yes. we can improve, extend or rethink what is already there when starting again would not make sense."],
        ["can you automate an existing manual process?", "usually, yes. we first understand the process, remove what is unnecessary and then automate the parts where technology genuinely helps."],
        ["can we come to you without knowing exactly what we need?", "absolutely. a clear problem is enough. sometimes even knowing that something should work better is a good place to begin."]
      ]
    },
    cta: {
      kicker: "a good place to start",
      title: "what could<br />work better?",
      text: "bring us the idea, the problem, or the thing you've been meaning to make better.",
      action: "start a project"
    }
  },
  de: {
    hero: {
      kicker: "dienstleistungen / thewhizkind",
      title: "unsere <span>dienst\u00ADleistungen</span>",
      intro: {
        lead: "ideen, design, technologie und business — im zusammenspiel.",
        text: "das kann eine webseite sein. manchmal geht es um corporate identity. ein andermal steht die automatisierung im zentrum, ein digitales werkzeug oder ein prozess, der einfach nicht mehr manuell erledigt werden sollte."
      }
    },
    index: {
      label: "leistungskategorien"
    },
    groups: {
      automation: {
        title: "ki, automatisierung & werkzeuge",
        slug: "ki-automatisierung-werkzeuge",
        formattedTitle: ["ki,", "automatisierung", "& werkzeuge"],
        intro: "weniger zeit für repetitive arbeiten. mehr raum für die aufgaben, die eines menschen bedürfen.",
        services: {
          aiAutomation: ["ki & automatisierung", "abläufe, die manuelle arbeiten sinnvoller gestalten, informationen vernetzen und die tägliche arbeit ein wenig einfacher machen."],
          privateLocalAi: ["private & lokale ki", "ki, die um deine eigenen daten und infrastruktur herum aufgebaut ist — damit vertrauliche informationen geschützt bleiben."],
          processOptimisation: ["prozessoptimierung", "unnötige schritte ausmachen und entscheiden, was vereinfacht, vernetzt oder automatisiert werden sollte."],
          customTools: ["individuelle werkzeuge", "existiert das richtige werkzeug nicht, bauen wir es einfach."]
        },
        inlineLink: "schau nach, womit wir experimentieren"
      },
      webDigital: {
        title: "web & digital",
        slug: "web-digital",
        intro: "digitale erfahrungen, die ganzheitlich entworfen und entwickelt werden — basierend darauf, was tatsächlich getan werden muss.",
        services: {
          webDevelopment: ["webentwicklung", "responsive, barrierefreie und schnelle websites — durchdacht gestaltet, sorgfältig umgesetzt."],
          digitalisation: ["digitalisierung", "manuelle, umständliche oder veraltete arbeitsweisen in praktische digitale prozesse verwandeln."]
        }
      },
      finance: {
        title: "finanzen & business",
        slug: "finanzen-geschäft",
        intro: "struktur in die geschäftsseite guter ideen bringen.",
        services: {
          finance: ["finanzen", "finanzielle aspekte in digitale projekte berücksichtigen und komplexe daten einfacher nutzbar machen."],
          creativeDevelopment: ["kreativentwicklung", "erste ideen in nützliche, realisierbare projekte mit klarer ausrichtung umsetzen."]
        }
      },
      brandDesign: {
        title: "marken & design",
        slug: "marken-design",
        intro: "corporate design und bürokommunikation, die eine idee klar, erkennbar und nutzbar machen.",
        services: {
          brandingIdentity: ["branding & identität", "von der ersten idee zu einem visualisierungssystem — wiedererkennbare corporate identity, typografie, farben und richtlinien."],
          graphicDesign: ["grafikdesign", "kampagnen, publikationen, präsentationen, poster und digitale inhalte — gestaltet, um klar und einheitlich zu kommunizieren."],
          communication: ["kommunikation", "informationen über verschiedene kanäle und zielgruppen hinweg klarer und einfacher verständlich machen"]
        },
        inlineLink: "schau dir ausgewählte grafikprojekte an"
      }
    },
    liveOnTheWeb: {
      title: "live im web"
    },
    process: {
      title: "wie wir arbeiten",
      sectionTitle: "kein festes rezept",
      steps: [
        ["01", "verstehen", "was ist eigentlich das problem?"],
        ["02", "nachdenken", "was würde es besser machen?"],
        ["03", "umsetzen", "es entwerfen. es bauen. es testen."],
        ["04", "verbessern", "denn version eins heißt nicht das ende."]
      ]
    },
    clients: {
      kicker: "mit wem wir arbeiten",
      title: "unterschied\u00ADliche größen.<br />gleiche neugier.",
      scale: "startups / organisationen / kultureinrichtungen / bildungswesen / unternehmen / unabhängige projekte",
      paths: [
        "einige kommen mit detaillierten vorstellungen.",
        "einige kommen mit einem problem.",
        "einige kommen mit zweifeln \"es muss eine bessere lösung geben\".",
        "einige stellen sich einfach vor."
      ],
      emphasis: "alles gute ausgangspunkte."
    },
    faq: {
      title: "gute fragen",
      sectionTitle: "bevor wir <span>beginnen</span>",
      questions: [
        ["arbeitet ihr nur an projekten in frankfurt?", "nein. wir haben unseren standort in frankfurt am main, ursprünglich in neu-delhi, und arbeiten mit verschiedenen menschen und organisationen über grenzen und zeitzonen hinweg."],
        ["könnt ihr design und entwicklung zusammen anbieten?", "ja. beides zusammenzubringen ist oft der beste weg, um eine idee von der ersten skizze bis zum fertigen ergebnis kohärent zu halten."],
        ["arbeitet ihr mit bestehenden websites und systemen?", "ja. wir können verbessern, erweitern oder überdenken, was bereits existiert, wenn eine neugestaltung keinen sinn machen würde."],
        ["könnt ihr einen bestehenden manuellen prozess automatisieren?", "in der regel ja. wir erfassen zunächst den prozess, entfernen, was unnötig ist, und automatisieren dann die bereiche, in denen technologie wirklich zielführend ist."],
        ["können wir zu euch kommen, ohne genau zu wissen, was wir brauchen?", "absolut. ein klares problem reicht aus. manchmal ist sogar das wissen, dass etwas besser funktionieren sollte, ein guter startpunkt."]
      ]
    },
    cta: {
      kicker: "ein guter startpunkt",
      title: "was könnte<br />besser funktionieren?",
      text: "bring uns die idee, das problem oder die sache, die du schon immer verbessern wolltest.",
      action: "projekt starten"
    }
  }
};

export default serviceTranslations;
